/**
 * @fileoverview Archivo que contiene las clases y funciones utiles para el contexto de la aplicacion.
 */

/**
 * Clase que representa una respuesta de la API.
 */
export class Respuesta {
  constructor(exito, mensaje) {
    this.exito = exito;
    this.mensaje = mensaje;
  }
}

/**
 * Obtiene la temporada actual (a partir de septiembre, temporada nueva).
 */
export function temporadaActual() {
  const month = new Date().getMonth();
  const year = new Date().getFullYear();

  // En JavaScript getMonth() es 0-indexed (enero es 0, septiembre es 8).
  // A partir de septiembre (mes >= 8), comienza la nueva temporada.
  if (month < 8) {
    return String(parseInt(year - 1)) + '-' + year;
  } else {
    return year + '-' + String(parseInt(year + 1));
  }
}
